import { SET_PROJECT } from 'app/store/actions/project'

const initialState = {
  id: '',
}

const project = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECT:
      return action.project
    default:
      return state
  }
}

export default project
